import { cn } from '@commenda/utils';
import React from 'react';

import { type AvatarProps } from '../../Avatar';
import { AvatarGroup } from '../../AvatarGroup';
import { TruncatedText } from '../../TruncatedText';
import { DATA_GRID_CELL_MAX_VISIBLE_AVATARS } from '../constants';

export interface DataGridCellAvatarProps {
  avatars: AvatarProps[];
  name?: React.ReactNode;
  maxVisible?: number;
  size?: AvatarProps['size'];
  leading?: React.ReactNode;
  className?: string;
}

const DataGridCellAvatar = ({
  avatars,
  name,
  maxVisible = DATA_GRID_CELL_MAX_VISIBLE_AVATARS,
  size = 'xs',
  leading,
  className,
}: DataGridCellAvatarProps) => (
  <div className={cn('flex w-full items-center gap-lg', className)}>
    {leading}
    <AvatarGroup
      avatars={avatars}
      limit={maxVisible}
      size={size}
      className="shrink-0"
    />
    {name ? (
      <TruncatedText className="txt-small-regular text-text-primary">
        {name}
      </TruncatedText>
    ) : null}
  </div>
);

export { DataGridCellAvatar };
